import '../style.scss';
import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import 'react-phone-input-2/lib/style.css';
import { IEditReportState, IPrivateSectorResultsAndBenefitsTab, IPrivateSectorResultsAndBenefitsItem, IPrivateSectorSplitUpValues, IReportCountriesIndicators, IRestorationPledgeTrackingDetailsTab, ICountriesPrivateSectorResultsAndBenefitsTab, ICountriesPrivateSectorSplitUpValues, ICountryPrivateSectorResultsAndBenefitsItem } from '../models/IEditReportState';
import { IRefPledgeEcosystemTypeFeature, IRefInterventionType, IRefConfidenceFeature, IRefRestorationAimsFeature, IRefCO2RestorationInterventionFeature, IRefJobsStakeholdersFeature } from '../models/IRefFeature';
import { IFeature } from '@esri/arcgis-rest-types';
import ConfigService from '../../../../shared/configService';
import Select, { MultiValue } from 'react-select';
import QueryService from '../../../../shared/queryService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faUpload, faDownload } from '@fortawesome/free-solid-svg-icons';
import { Modal, Placeholder } from 'react-bootstrap';
import { IRefTierFeature, IRefCO2EstimationSystem, IRefJobMeasureUnit, IRefJobTypesFeature } from '../models/IRefFeature';
import Accordion from 'react-bootstrap/Accordion';
import Utils from '../../../../shared/utils';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { render } from 'react-dom';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import CountryGuildLineSplash from '../../../splash/CountryGuildLineSplash'
import { saveAs } from "file-saver";
import MultiSelectAutocomplete from './../../../common/autocomplete/MultiSelectAutocomplete';
import { Spinner } from 'react-bootstrap';
import LoadingOverlay from 'react-loading-overlay';
import ActivitiesUpload from './ActivitiesUpload';
const SectorResultsAndBenefits = (props: { state: IEditReportState, setState: Function, validateData: Function, content: any }) => {
  const { t } = useTranslation('sectorreports');
  const MAX_LENGTH = ConfigService.getConfig().textEditorCharLength;

  // State
  interface ILocalState {
    reportRBLayerIndex: number;
    reportRBJobsLayerIndex: number;
    refPledgeEcosystemTypeFeatures: IRefPledgeEcosystemTypeFeature[];
    refInterventionTypeFeatures: IRefInterventionType[];
    tiersFeatures: IRefTierFeature[];
    refCO2EstimationSystemFeatures: IRefCO2EstimationSystem[],
    refJobMeasureUnitFeatures: IRefJobMeasureUnit[],
    confidenceFeature: IRefConfidenceFeature[];
    refRestorationAimsFeature: IRefRestorationAimsFeature[];
    refRestorationInterventionFeature: IRefCO2RestorationInterventionFeature[];
    refJobsStakeholdersFeature: IRefJobsStakeholdersFeature[];
    jobTypesFeature: IRefJobTypesFeature[];
    otherCO2EstimationSystemInputEnabled: boolean,
    otherCO2EmissionOtherInputEnabled: boolean,
    otherCO2CertificationInputEnabled: boolean,
    otherJobsStakerholdersInputEnabled: boolean,
    otherJobsStakerholdersLongTermInputEnabled: boolean,
    privateSectorAreaOfLandTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorClimateImpactsTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorBiodiversityImpactsTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorSocioEconomicImpactsTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    treeData: any[],
    treeDataCopy: any[],
    treeCountryData: any[],
    treeCountryDataCopy: any[],
    splitSelectRow: any,
    splitCountrySelectRow: any,
    originalData: any[],
    originalCountryData: any[],
    isOpen: boolean,
    isFetchingReportData: boolean,
    selectedCountryId: string,
    selectedCountryName: string
  }

  const [localState, setTheLocalState] = useState<ILocalState>({
    reportRBLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportRb.index,
    reportRBJobsLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportRbJobs.index,
    refPledgeEcosystemTypeFeatures: [],
    refInterventionTypeFeatures: [],
    tiersFeatures: [],
    refCO2EstimationSystemFeatures: [],
    refJobMeasureUnitFeatures: [],
    confidenceFeature: [],
    refRestorationAimsFeature: [],
    refRestorationInterventionFeature: [],
    refJobsStakeholdersFeature: [],
    jobTypesFeature: [],
    otherCO2EstimationSystemInputEnabled: false,
    otherCO2EmissionOtherInputEnabled: false,
    otherCO2CertificationInputEnabled: false,
    otherJobsStakerholdersInputEnabled: false,
    otherJobsStakerholdersLongTermInputEnabled: false,
    privateSectorAreaOfLandTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorClimateImpactsTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorBiodiversityImpactsTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorSocioEconomicImpactsTab: {
      isActive: false,
      isDisabled: false
    },
    treeData: [],
    treeDataCopy: [],
    treeCountryData: [],
    treeCountryDataCopy: [],
    splitSelectRow: 0,
    splitCountrySelectRow: '0',
    originalData: [],
    originalCountryData: [],
    isOpen: false,
    isFetchingReportData: false,
    selectedCountryId: '',
    selectedCountryName: ''
  });
  const [isOpen, setIsOpen] = useState(false);
  // Confirm dialog
  const [showRevertToGlobalDialog, setRevertToGlobalDialogShow] = useState(false);

  const [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateArea, setEditorStateArea] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateRevInfo, setEditorStateRevInfo] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateRevCit, setEditorStateRevCit] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateCo2Seq, setEditorStateCo2Seq] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateCo2Link, setEditorStateCo2Link] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateBioImp, setEditorStateBioImp] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateBioRed, setEditorStateBioRed] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateBioLink, setEditorStateBioLink] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateSeasonalEcoBen, setEditorStateSeasonalEcoBen] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateLongTermEcoBen, setEditorStateLongTermEcoBen] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateSeasonalRevEco, setEditorStateSeasonalRevEco] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateLongTermRevEco, setEditorStateLongTermRevEco] = useState(
    () => EditorState.createEmpty(),
  );

  const handleEditorChangeArea = (state: any) => {
    setEditorStateArea(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateArea.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(0, 'area_restoration_system', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeRevInfo = (state: any) => {
    setEditorStateRevInfo(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateRevInfo.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(0, 'ha_information', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeRevCit = (state: any) => {
    setEditorStateRevCit(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateRevCit.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(0, 'ha_links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeCo2Seq = (state: any) => {
    setEditorStateCo2Seq(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateCo2Seq.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(1, 'co2_information', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeCo2Link = (state: any) => {
    setEditorStateCo2Link(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateCo2Link.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(1, 'co2_links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeBioRed = (state: any) => {
    setEditorStateBioRed(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateBioRed.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(2, 'bio_redlist', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeBioLink = (state: any) => {
    setEditorStateBioLink(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateBioLink.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedResultsAndBenefitsItem(2, 'bio_links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeSeasonalEcoBen = (state: any) => {
    setEditorStateSeasonalEcoBen(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateSeasonalEcoBen.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedSocioEconomicImpactItem(0, 'eco_other', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeLongTermEcoBen = (state: any) => {
    setEditorStateLongTermEcoBen(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateLongTermEcoBen.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedSocioEconomicImpactItem(2, 'eco_other', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeSeasonalRevEco = (state: any) => {
    setEditorStateSeasonalRevEco(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateSeasonalRevEco.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedSocioEconomicImpactItem(0, 'eco_links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorChangeLongTermRevEco = (state: any) => {
    setEditorStateLongTermRevEco(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateLongTermRevEco.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }
    
    updateSelectedSocioEconomicImpactItem(2, 'eco_links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const [isNewRow, setIsNewRow] = useState(false);

  // Use effect
  let propscontentLink: any = '';
  useEffect(() => {
    localState.isFetchingReportData = true;
    //Set tabs state
    enableDisableTabs(props.state.restorationPledgeTrackingDetailsTab?.location_specific, '');

    const obj: IEditReportState = { ...props.state } as IEditReportState;

    const subObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;

    if (subObj && subObj.countryprivateSectorResultsAndBenefitsItems?.length) {
      addResultsAndBenefitsItem(true);
    }

    const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

    const contentState = ContentState.createFromBlockArray(
      contentBlocks.contentBlocks,
      contentBlocks.entityMap
    );

    setEditorState(EditorState.createWithContent(contentState));

    loadContentData(props.state.privateSectorResultsAndBenefitsTab!, false);

    //Reference table
    getRefFeatures();

    getThreatenedSpeciesByPageListFeatures();

    localState.isFetchingReportData = false;

  }, [propscontentLink, props.state.restorationPledgeTrackingDetailsTab?.impact_indicators, isNewRow]);


  const loadContentData = (val: any, isCountrySwtich: boolean) => {
    if (getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.area_restoration_system) {
      propscontentLink = isCountrySwtich && val.privateSectorAreaOfLandTab?.area_restoration_system != undefined ? val.privateSectorAreaOfLandTab?.area_restoration_system?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.area_restoration_system?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateArea(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateArea(EditorState.createWithContent(contentState));
    }


    if (getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_information) {
      propscontentLink = isCountrySwtich && val.privateSectorAreaOfLandTab?.ha_information != undefined ? val.privateSectorAreaOfLandTab?.ha_information?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_information?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateRevInfo(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateRevInfo(EditorState.createWithContent(contentState));
    }


    if (getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_links) {
      propscontentLink = isCountrySwtich && val.privateSectorAreaOfLandTab?.ha_links != undefined ? val.privateSectorAreaOfLandTab?.ha_links?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateRevCit(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateRevCit(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_information) {
      propscontentLink = isCountrySwtich && val.privateSectorClimateImpactsTab?.co2_information != undefined ? val.privateSectorClimateImpactsTab?.co2_information?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_information?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateCo2Seq(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateCo2Seq(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_links) {
      propscontentLink = isCountrySwtich && val.privateSectorClimateImpactsTab?.co2_links != undefined ? val.privateSectorClimateImpactsTab?.co2_links?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateCo2Link(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateCo2Link(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_redlist) {
      propscontentLink = isCountrySwtich && val.privateSectorBiodiversityImpactsTab?.bio_redlist != undefined ? val.privateSectorBiodiversityImpactsTab?.bio_redlist?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_redlist?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateBioRed(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateBioRed(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_links) {
      propscontentLink = isCountrySwtich && val.privateSectorBiodiversityImpactsTab?.bio_links != undefined ? val.privateSectorBiodiversityImpactsTab?.bio_links?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateBioLink(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateBioLink(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_other) {
      propscontentLink = isCountrySwtich && val.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_other != undefined ? val.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_other?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_other?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateSeasonalEcoBen(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateSeasonalEcoBen(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_other) {
      propscontentLink = isCountrySwtich && val.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_other != undefined ? val.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_other?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_other?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateLongTermEcoBen(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateLongTermEcoBen(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_links) {
      propscontentLink = isCountrySwtich && val.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_links != undefined ? val.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_links?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateSeasonalRevEco(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateSeasonalRevEco(EditorState.createWithContent(contentState));
    }

    if (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_links) {
      propscontentLink = isCountrySwtich && val.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_links != undefined ? val.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_links?.toString() : getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateLongTermRevEco(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStateLongTermRevEco(EditorState.createWithContent(contentState));
    }
  }

  const loadAddNewContentData = () => {

    const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(''));
    const contentState = ContentState.createFromBlockArray(
      contentBlocks.contentBlocks,
      contentBlocks.entityMap
    );
    //1.Areaofland
    setEditorStateArea(EditorState.createWithContent(contentState));
    setEditorStateRevInfo(EditorState.createWithContent(contentState));
    setEditorStateRevCit(EditorState.createWithContent(contentState));

    //2. Climate
    setEditorStateCo2Seq(EditorState.createWithContent(contentState));
    setEditorStateCo2Link(EditorState.createWithContent(contentState));

    //3. Biodiversity
    setEditorStateBioRed(EditorState.createWithContent(contentState));
    setEditorStateBioLink(EditorState.createWithContent(contentState));

    //4. Economy
    setEditorStateSeasonalEcoBen(EditorState.createWithContent(contentState));
    setEditorStateLongTermEcoBen(EditorState.createWithContent(contentState));
    setEditorStateSeasonalRevEco(EditorState.createWithContent(contentState));
    setEditorStateLongTermRevEco(EditorState.createWithContent(contentState));
  }

  /**
   * Enable disable tab
   * @param index 
   */
  const enableDisableTabs = (locationSpec: any, selectectItem: any) => {
    const obj: ILocalState = { ...localState };
    let flag: boolean = false;

    if (locationSpec != 1) {
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('5') === -1) {
        obj.privateSectorAreaOfLandTab.isDisabled = true;
        obj.privateSectorAreaOfLandTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('6') === -1) {
        obj.privateSectorClimateImpactsTab.isDisabled = true;
        obj.privateSectorClimateImpactsTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('7') === -1) {
        obj.privateSectorBiodiversityImpactsTab.isDisabled = true;
        obj.privateSectorBiodiversityImpactsTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('8') === -1) {
        obj.privateSectorSocioEconomicImpactsTab.isDisabled = true;
        obj.privateSectorSocioEconomicImpactsTab.isActive = false;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('5') !== -1) {
        obj.privateSectorAreaOfLandTab.isDisabled = false;
        //obj.policiesAndStrategiesTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('6') !== -1) {
        obj.privateSectorClimateImpactsTab.isDisabled = false;
        //obj.privateSectorTechnicalPlanningTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('7') !== -1) {
        obj.privateSectorBiodiversityImpactsTab.isDisabled = false;
        //obj.privateSectorFinancialFlowsTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('8') !== -1) {
        obj.privateSectorSocioEconomicImpactsTab.isDisabled = false;
        //obj.privateSectorMonitoringTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('5') !== -1 && !flag) {
        flag = true;
        obj.privateSectorAreaOfLandTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('6') !== -1 && !flag) {
        flag = true;
        obj.privateSectorClimateImpactsTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('7') !== -1 && !flag) {
        flag = true;
        obj.privateSectorBiodiversityImpactsTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators?.indexOf('8') !== -1 && !flag) {
        flag = true;
        obj.privateSectorSocioEconomicImpactsTab.isActive = true;
      }
    }
    else {
      props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((el: IReportCountriesIndicators, i: number) => {       
        if (localState.selectedCountryId == el.country_id) {
          obj.privateSectorAreaOfLandTab.isDisabled = false;
          obj.privateSectorClimateImpactsTab.isDisabled = false;
          obj.privateSectorBiodiversityImpactsTab.isDisabled = false;
          obj.privateSectorSocioEconomicImpactsTab.isDisabled = false;
          //obj.privateSectorAreaOfLandTab.isActive = false;
          obj.privateSectorClimateImpactsTab.isActive = false;
          obj.privateSectorBiodiversityImpactsTab.isActive = false;
          obj.privateSectorSocioEconomicImpactsTab.isActive = false;
          if (el.impact_indicator?.indexOf('5') == -1) {
            obj.privateSectorAreaOfLandTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('6') == -1) {
            obj.privateSectorClimateImpactsTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('7') == -1) {
            obj.privateSectorBiodiversityImpactsTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('8') == -1) {
            obj.privateSectorSocioEconomicImpactsTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('5') != -1) {
            obj.privateSectorAreaOfLandTab.isDisabled = false;
          }

          if (el.impact_indicator?.indexOf('6') != -1) {
            obj.privateSectorClimateImpactsTab.isDisabled = false;
          }

          if (el.impact_indicator?.indexOf('7') != -1) {
            obj.privateSectorBiodiversityImpactsTab.isDisabled = false;
          }

          if (el.impact_indicator?.indexOf('8') != -1) {
            obj.privateSectorSocioEconomicImpactsTab.isDisabled = false;
          }

          if (el.impact_indicator?.indexOf('5') !== -1 && !flag) {
            flag = true;
            obj.privateSectorAreaOfLandTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('6') !== -1 && !flag) {
            flag = true;
            obj.privateSectorClimateImpactsTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('7') !== -1 && !flag) {
            flag = true;
            obj.privateSectorBiodiversityImpactsTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('8') !== -1 && !flag) {
            flag = true;
            obj.privateSectorSocioEconomicImpactsTab.isActive = true;
          }
        }

        else if (i == 0) {
          if (el.impact_indicator?.indexOf('5') == -1) {
            obj.privateSectorAreaOfLandTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('6') == -1) {
            obj.privateSectorClimateImpactsTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('7') == -1) {
            obj.privateSectorBiodiversityImpactsTab.isDisabled = true;
          }

          if (el.impact_indicator?.indexOf('8') == -1) {
            obj.privateSectorSocioEconomicImpactsTab.isDisabled = true;
          }
          if (el.impact_indicator?.indexOf('5') !== -1 && !flag) {
            flag = true;
            obj.privateSectorAreaOfLandTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('6') !== -1 && !flag) {
            flag = true;
            obj.privateSectorClimateImpactsTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('7') !== -1 && !flag) {
            flag = true;
            obj.privateSectorBiodiversityImpactsTab.isActive = true;
          }

          if (el.impact_indicator?.indexOf('8') !== -1 && !flag) {
            flag = true;
            obj.privateSectorSocioEconomicImpactsTab.isActive = true;
          }
        }
      });
    }


    setTheLocalState(obj);
  }

  /**
   * Get reference list
   */
  const getRefFeatures = async () => {

    const jobTypFeature = [
      { key_: '1', value: t("newReport.resultsAndBenefits.seasonalJobType") },
      { key_: '2', value: t("newReport.resultsAndBenefits.longTermJobType") },
      { key_: '3', value: t("newReport.resultsAndBenefits.bothJobType") }
    ];

    // Ref data
    const countryTiers = "reporting_entity_type = '1'";
    const sectorTiers = "reporting_entity_type = '2'";
    const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
    const ecosystemTypeFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index);
    const interventionTypes: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_INTERVENTION_TYPE.index);
    const cO2EstimationSystemFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_ESTIMATION_SYSTEM.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_CO2_ESTIMATION_SYSTEM.fields.key} ASC`);
    const tierFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_TIERS.index), countryTiers, false, '*', '');
    const measureUnitFeaturesFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_JOB_MEASURE_UNIT.index);
    const confidenceDataFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_TIERS.index), sectorTiers, false, '*', '');
    const restorationAimsFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_RES_INTERVENTION_AIM.index), '', false, '*', '');
    const cO2RestorationInterventionFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_RES_INTERVENTIONS.index), '', false, '*', '');
    const jobStakesholdersFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_JOB_STAKEHOLDERS.index), '', false, '*', '');

    const obj: ILocalState = { ...localState };
    //let objtemp: any = [];
    obj.refPledgeEcosystemTypeFeatures = ecosystemTypeFeatures.map((feat: IFeature) => feat.attributes as IRefPledgeEcosystemTypeFeature);
    obj.refInterventionTypeFeatures = interventionTypes.map((feat: IFeature) => feat.attributes as IRefInterventionType);
    obj.tiersFeatures = tierFeatures.map((feat: IFeature) => feat.attributes as IRefTierFeature);
    obj.refCO2EstimationSystemFeatures = cO2EstimationSystemFeatures.map((feat: IFeature) => feat.attributes as IRefCO2EstimationSystem);
    obj.refJobMeasureUnitFeatures = measureUnitFeaturesFeatures.map((feat: IFeature) => feat.attributes as IRefJobMeasureUnit);
    obj.confidenceFeature = confidenceDataFeature.map((feat: IFeature) => feat.attributes as IRefConfidenceFeature);
    obj.refRestorationAimsFeature = restorationAimsFeature.map((feat: IFeature) => feat.attributes as IRefRestorationAimsFeature);
    obj.refRestorationInterventionFeature = cO2RestorationInterventionFeature.map((feat: IFeature) => feat.attributes as IRefCO2RestorationInterventionFeature);
    obj.refJobsStakeholdersFeature = jobStakesholdersFeature.map((feat: IFeature) => feat.attributes as IRefJobsStakeholdersFeature);
    obj.jobTypesFeature = jobTypFeature;

    // Get layer infos
    await QueryService.getLayerFieldsInfos(localState.reportRBLayerIndex);
    await QueryService.getLayerFieldsInfos(localState.reportRBJobsLayerIndex);

    const filtered = obj.refInterventionTypeFeatures
      .filter((i: IRefInterventionType) => {
        //return (props.state.restorationPledgeTrackingTab?.ecosystems || '').split(',').indexOf(i.ecosystem_id || '---') !== -1
        return (props.state.restorationPledgeTrackingTab?.ecosystems || '').indexOf(i.ecosystem_id || '---') !== -1
      });

    obj.treeData[0] = createIntervTypesDataTree(filtered);
    obj.treeCountryData[0] = createCountryIntervTypesDataTree(filtered);
    if (obj.treeDataCopy.length === 0) {
      obj.treeDataCopy = createIntervTypesDataTree(filtered);
      obj.originalData = createIntervTypesDataTree(filtered);
    }

    if (obj.treeCountryDataCopy.length === 0) {
      obj.treeCountryDataCopy = createCountryIntervTypesDataTree(filtered);
      obj.originalCountryData = createCountryIntervTypesDataTree(filtered);
    }

    let i = 0;
    let intervention_type_id: number;
    if (props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode && props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues!.length != 0) {
      props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues!.forEach((el: IPrivateSectorSplitUpValues) => {
        intervention_type_id = Number([el.intervention_type_id]);
        if (intervention_type_id != 0) {
          getSelectedInterventionTypes([intervention_type_id], i, obj);
          obj.treeData[i] = (JSON.parse(JSON.stringify(obj.treeData[i])));
          i = i + 1;
        }
      });
    }
   
    let j = 0;
    let country_intervention_type_id: number;
    if (props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.length != 0) {
      props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.forEach((el: ICountriesPrivateSectorSplitUpValues) => {
        country_intervention_type_id = Number([el.intervention_type_id]);
        if (country_intervention_type_id != 0) {
          getCountrySelectedInterventionTypes([country_intervention_type_id], [j], obj, el.country_id);
          obj.treeCountryData[j] = (JSON.parse(JSON.stringify(obj.treeCountryData[j])));
          j = j + 1;
        }
      });
    }           

    props.state.privateSectorResultsAndBenefitsTab?.privateSectorResultsAndBenefitsItems?.forEach((ele: IPrivateSectorResultsAndBenefitsItem) => {
      setSelectedSpeciesName(ele.privateSectorBiodiversityImpactsTab.bio_information)
    });

    props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryprivateSectorResultsAndBenefitsItems?.forEach((ele: ICountryPrivateSectorResultsAndBenefitsItem) => {
      if (ele.gid0 == localState.selectedCountryId) {
        setSelectedSpeciesName(ele.privateSectorBiodiversityImpactsTab.bio_information)
      }
    });

    setTheLocalState(obj);
  };


  /**
   * Get selected results and benefits item
   * @returns 
   */
  const getSelectedResultsAndBenefitsItem = (): IPrivateSectorResultsAndBenefitsItem | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
      const subCountryObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;

      if (localState.selectedCountryId == '' && subObj.isGlobalMode) {
        return subObj.privateSectorResultsAndBenefitsItems?.find((p: IPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive);
      }
      else
      {
        if(localState.selectedCountryId == '')
        {
          let countryData = subCountryObj.countryprivateSectorResultsAndBenefitsItems?.find((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive); 
          if(countryData != undefined)
          {
            localState.selectedCountryId = countryData.gid0!;
          }
          return subCountryObj.countryprivateSectorResultsAndBenefitsItems?.find((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive);                
        }else
        {
          return subCountryObj.countryprivateSectorResultsAndBenefitsItems?.find((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive && p.gid0 == localState.selectedCountryId);                
        }        
        
      }
    }

    return undefined;
  }

  /**
   * Get selected results and benefits item index
   * @returns 
   */
  const getSelectedResultsAndBenefitsItemIndex = (): number => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
      const subCountryObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;

      if (props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode) {
        return (subObj.privateSectorResultsAndBenefitsItems || []).findIndex((p: IPrivateSectorResultsAndBenefitsItem) => p.isActive);
      }
      else {
        return (subCountryObj.countryprivateSectorResultsAndBenefitsItems || []).findIndex((p: ICountryPrivateSectorResultsAndBenefitsItem) => p.isActive);
      }
    }

    return -1;
  }


  /**
   * Handle breakdown or revert report
   */
  const handleBreakdownOrRvertReportClick = async () => {
    handleRevertToGlobalDialogShow();
  }

  /**
   * Handle breakdown or revert report confirm
   */
  const handleBreakdownOrRvertReportConfirm = async () => {
    let features: IFeature[] = [];
    //let countryLevel: boolean = true;

    // 1) Global mode
    if (props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode) {
      // Country level 
      const countries: IFeature[] = await QueryService.queryGADMFeatures(ConfigService.getConfig().agol.gadmLayers.gadm_0.index, `${ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.name0} ASC`);
      let selectedCountries: IFeature[] = [];
      // Country level
      let i = 0;
      props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((el: IReportCountriesIndicators) => {
        countries.map((country: IFeature) => {
          const report: any | undefined = (el.country_indicator == country.attributes['NAME_0']);
          //const report: any | undefined = (el.country_id == country.attributes['GID_0']);
          if (report == true) {
            selectedCountries[i] = (JSON.parse(JSON.stringify(country)));
            i = i + 1;
          }
        });
      });

      features = selectedCountries;

      if (features.length) {
        props.state.privateSectorResultsAndBenefitsTab!.isGlobalMode = false;
        addResultsAndBenefitsItem(true, features);
        loadContentData(props.state.countriesPrivateSectorResultsAndBenefitsTab!, true);
      }
      //Reference table
      getRefFeatures();
    }

    // 2) Breakpoint mode
    else {
      addResultsAndBenefitsItem(true);
      props.state.privateSectorResultsAndBenefitsTab!.isGlobalMode = true;
      loadContentData(props.state.privateSectorResultsAndBenefitsTab!, false);
      
      getRefFeatures();
    }
  }

  /**
   * Select tab
   * @param index 
   */
  const selectTab = (index: number) => {
    const obj: ILocalState = { ...localState };

    obj.privateSectorAreaOfLandTab.isActive = index === 0;
    obj.privateSectorClimateImpactsTab.isActive = index === 1;
    obj.privateSectorBiodiversityImpactsTab.isActive = index === 2;
    obj.privateSectorSocioEconomicImpactsTab.isActive = index === 3;

    setTheLocalState(obj);
  }

  /**
   * Create interventions types tree data
   * @param dataset
   * @returns
   */
  const createIntervTypesDataTree = (dataset: IRefInterventionType[]): any[] => {
    let res: any[] = [];
    dataset.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.value) {
        setChildren(el, dataset);
        res.push(getMultiselectItem(el));
      }
    });

    res.sort((a, b) => a.label.localeCompare(b.label));

    // Add ecosystems on top level (multiply ecosystem_id by 1000 to resolve tree problem)
    const addedEcosystemsIds: number[] = [];
    const ecosystemsItems: any[] = [];
    res.forEach((el: IRefInterventionType) => {
      if (el.ecosystem_id && addedEcosystemsIds.indexOf(Number(el.ecosystem_id) * 1000) === -1) {
        ecosystemsItems.push({ label: el.ecosystem, id: Number(el.ecosystem_id) * 1000, children: [], className: "treeFirstLevel" });
        addedEcosystemsIds.push(Number(el.ecosystem_id) * 1000)
      }
    });

    // Set parent key
    res.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.key_) {
        el.parent_key = Number(el.ecosystem_id) * 1000
      }
    });

    ecosystemsItems.forEach((item: any) => {
      res.forEach((el: IRefInterventionType, i: number) => {
        if (el.parent_key === item.id) {
          item.children.push(el);
        }
      });
    });

    ecosystemsItems.sort((a, b) => a.label.localeCompare(b.label));
    return ecosystemsItems;
  };

  /**
   * Create interventions types tree data
   * @param dataset
   * @returns
   */
  const createCountryIntervTypesDataTree = (dataset: IRefInterventionType[]): any[] => {
    let res: any[] = [];
    dataset.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.value) {
        setChildren(el, dataset);
        res.push(getMultiselectItem(el));
      }
    });

    res.sort((a, b) => a.label.localeCompare(b.label));

    // Add ecosystems on top level (multiply ecosystem_id by 1000 to resolve tree problem)
    const addedEcosystemsIds: number[] = [];
    const ecosystemsItems: any[] = [];
    res.forEach((el: IRefInterventionType) => {
      if (el.ecosystem_id && addedEcosystemsIds.indexOf(Number(el.ecosystem_id) * 1000) === -1) {
        ecosystemsItems.push({ label: el.ecosystem, id: Number(el.ecosystem_id) * 1000, children: [], className: "treeFirstLevel", countryId: '' });
        addedEcosystemsIds.push(Number(el.ecosystem_id) * 1000)
      }
    });

    // Set parent key
    res.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.key_) {
        el.parent_key = Number(el.ecosystem_id) * 1000
      }
    });

    ecosystemsItems.forEach((item: any) => {
      res.forEach((el: IRefInterventionType, i: number) => {
        if (el.parent_key === item.id) {
          item.children.push(el);
        }
      });
    });

    ecosystemsItems.sort((a, b) => a.label.localeCompare(b.label));
    return ecosystemsItems;
  };

  const setChildren = (item: IRefInterventionType, dataset: IRefInterventionType[]) => {

    dataset.forEach((el: IRefInterventionType) => {
      if (el.value && el.parent_key === item.key_) {
        setChildren(el, dataset);
        if (item.children) {
          const exists = item.children.find(i => i.key_ === el.key_);

          if (!exists) {
            item.children.push(getMultiselectItem(el));
          }
        } else {
          item.children = [getMultiselectItem(el)];
        }

        item.children.sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }

  const getMultiselectItem = (item: IRefInterventionType) => {
    return { ...item, ... { label: item.value, id: item.key_ } };
  }


  /**
   * Add new results and benefits Item
   * @param clearItems 
   * @param features
   */
  const addResultsAndBenefitsItem = (clearItems: boolean = false, features: IFeature[] = Object.create(null)) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const rbTab: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
      const rbCountryTab: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;
      const restorePlegdeDetailTab: IRestorationPledgeTrackingDetailsTab = { ...obj.restorationPledgeTrackingDetailsTab } as IRestorationPledgeTrackingDetailsTab;
      const items = features && features.length ? features.reverse().map((feat: IFeature, i: number) => initRBItem(feat)) : [];
      const oneItem: ICountryPrivateSectorResultsAndBenefitsItem = items && items.length ? items.reverse()[0] : initRBItem(Object.create(null));

      // Is Global
      if (oneItem.gid0) {
        rbTab.isGlobalMode = false;
      } else {
        rbTab.isGlobalMode = true;
      }

      if(restorePlegdeDetailTab.location_specific == '1')
      { 
        // Clear items
        if (clearItems) {
          // Store delete objects ids
          setDeleteObjectids(rbCountryTab);

          //rbCountryTab.countryprivateSectorResultsAndBenefitsItems = [];
        }

        // Add new results and benefits Item
        //rbCountryTab.countryprivateSectorResultsAndBenefitsItems = items && items.length ? items.reverse() : [oneItem];
            
        oneItem.sectorReportCountries!.forEach((reportCountries: IReportCountriesIndicators,i: number) => 
        {
          if((rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.filter((j:ICountryPrivateSectorResultsAndBenefitsItem)=>j.gid0 ==reportCountries.country_id).length) ==0)
            {
              const item: ICountryPrivateSectorResultsAndBenefitsItem = {
                isActive: true,
                isOK: false,      
                name0: reportCountries.country_indicator,
                gid0: reportCountries.country_id,
                OBJECTID: -1,
                report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID],
                privateSectorAreaOfLandTab: {
                  isOK: false,
                  ha_restoration_data: '',
                  ha_under_resto: 0,
                  ha_imp_year: 0,
                  ha_tier: '',
                  ha_information: '',
                  ha_links: '',
                  relevant_geospatial_data: '',
                  area_restoration_system: '',
                  ha_resto_intervention_link: ''
                },
                privateSectorClimateImpactsTab: {
                  isOK: true,
                  co2_sequestered: 0,
                  co2_tier: '',
                  co2_systems: '',
                  co2_information: '',
                  restoration_interventions_aim: '',
                  co2_restoration_interventions: '',
                  co2_links: '',
                  co2_other: '',
                  co2_contribution: 0,
                  co2_other_tool: '',
                  co2_certification: '',
                },
                privateSectorBiodiversityImpactsTab: {
                  isOK: true,
                  bio_information: '',
                  bio_protarea_ha: 0,
                  bio_nativearea_ha: 0,
                  bio_primarea_ha: 0,
                  bio_intactarea_ha: 0,
                  bio_redlist: '',
                  bio_links: '',
                  bio_ha_threat_species: 0
                },
                privateSectorSocioEconomicImpactsTab: {
                  isOK: true,
                  job_type: '1',
                  psSeasonalCasualOccasional: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType },
                  psLongTerm: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType }                
                },
                sectorReportCountries: props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators
              }

              rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.push(item);
            }  
        });
        
        if(rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.length != oneItem.sectorReportCountries?.length)
        {        
          const countyList: string[] = [];      
          oneItem.sectorReportCountries!.forEach((sectorRes: any,i: number) =>
          {
            countyList.push(sectorRes.country_id);
          })

          rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.forEach((ps: ICountryPrivateSectorResultsAndBenefitsItem,i: number) =>
          {
            if(!countyList.includes(ps.gid0!))
            {
              rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.splice(i, 1);
            }
          })
        }

        rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.forEach((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => {
          p.isActive = i === 0;
          p.sectorReportCountries = oneItem.sectorReportCountries;
        });

        
        // Delete empty items
        if (rbCountryTab.countryprivateSectorResultsAndBenefitsItems && rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.length > 1) {
          rbCountryTab.countryprivateSectorResultsAndBenefitsItems = rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.filter((p: ICountryPrivateSectorResultsAndBenefitsItem) => {
            return p.gid0;
          });
        }

        obj.privateSectorResultsAndBenefitsTab = rbTab;

        if (rbCountryTab?.countryprivateSectorResultsAndBenefitsItems!.length > 0) {
          obj.countriesPrivateSectorResultsAndBenefitsTab! = rbCountryTab;
        }
        else {
          items!.forEach((jItem: ICountryPrivateSectorResultsAndBenefitsItem, k: number) => {
            if (k == 0) {
              jItem.isActive = true;
            }
            else {
              jItem.isActive = false;
            }
            obj.countriesPrivateSectorResultsAndBenefitsTab!.countryprivateSectorResultsAndBenefitsItems!.push(jItem);
          });

        }


        if (rbTab.isGlobalMode) {
          if (obj.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length > 0) {
            obj.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![0].isActive = true;
            localState.selectedCountryId = '';
            localState.selectedCountryName = '';
          }
        }
        else {

          if (obj.countriesPrivateSectorResultsAndBenefitsTab!.countryprivateSectorResultsAndBenefitsItems!.length > 0) {
            if (obj.countriesPrivateSectorResultsAndBenefitsTab!.countryprivateSectorResultsAndBenefitsItems!.length > 0) {
              obj.countriesPrivateSectorResultsAndBenefitsTab!.countryprivateSectorResultsAndBenefitsItems?.forEach((ele: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => {
                if (i == 0) {
                  ele.isActive = true;
                  localState.selectedCountryId = ele.gid0!;
                  localState.selectedCountryName = ele.name0!;
                }
                else {
                  ele.isActive = false;
                }
              })
            }
          }

          // if(rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.length != rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues?.length)
          // {        
            const countyItemList: string[] = [];     
            let systemValue: any[] = [];
            let k = 0; 
            rbCountryTab.countryprivateSectorResultsAndBenefitsItems?.forEach((sectorResItm: any,i: number) =>
            {
              countyItemList.push(sectorResItm.gid0!);
            })
            
          
            rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues.forEach((pSplit: ICountriesPrivateSectorSplitUpValues,i: number) =>
            {            
              if(countyItemList.includes(pSplit.country_id))
              {
                pSplit.resto_split_id = k.toString();
                systemValue.push(pSplit);
                k = k + 1;              
              }
            })
          //}

          rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues = systemValue;

          if(countyItemList.length > 0 && rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues.length == 0)
            {
              const emptyCountryRow: ICountriesPrivateSectorSplitUpValues = {
                isOK: false,
                isActive: true,
                OBJECTID: -1,
                resto_split_id: '0',
                report_rb_id: '',
                ecosystem_id: '',
                intervention_type_id: '',
                splitup_value: '',
                country_id: '',
                country_name: ''
              }
              rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues?.push(emptyCountryRow);
            }

          rbCountryTab.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues.forEach((jSplit: ICountriesPrivateSectorSplitUpValues, k: number) => {
            if (k == 0) {
              jSplit.country_id = localState.selectedCountryId;
              jSplit.country_name = localState.selectedCountryName;            
            }
          });
        }

        obj.countriesPrivateSectorResultsAndBenefitsTab! = rbCountryTab;
      }
      else
      {
        rbTab.isGlobalMode = true;
        if (rbTab.isGlobalMode) {
          if (obj.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length > 0) {
            obj.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![0].isActive = true;
            localState.selectedCountryId = '';
            localState.selectedCountryName = '';
          }
        }
        else
        {
          const item: ICountryPrivateSectorResultsAndBenefitsItem = {
            isActive: true,
            isOK: false,      
            name0: undefined,
            gid0: undefined,
            OBJECTID: -1,
            report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID],
            privateSectorAreaOfLandTab: {
              isOK: false,
              ha_restoration_data: '',
              ha_under_resto: 0,
              ha_imp_year: 0,
              ha_tier: '',
              ha_information: '',
              ha_links: '',
              relevant_geospatial_data: '',
              area_restoration_system: '',
              ha_resto_intervention_link: ''
            },
            privateSectorClimateImpactsTab: {
              isOK: true,
              co2_sequestered: 0,
              co2_tier: '',
              co2_systems: '',
              co2_information: '',
              restoration_interventions_aim: '',
              co2_restoration_interventions: '',
              co2_links: '',
              co2_other: '',
              co2_contribution: 0,
              co2_other_tool: '',
              co2_certification: '',
            },
            privateSectorBiodiversityImpactsTab: {
              isOK: true,
              bio_information: '',
              bio_protarea_ha: 0,
              bio_nativearea_ha: 0,
              bio_primarea_ha: 0,
              bio_intactarea_ha: 0,
              bio_redlist: '',
              bio_links: '',
              bio_ha_threat_species: 0
            },
            privateSectorSocioEconomicImpactsTab: {
              isOK: true,
              job_type: '1',
              psSeasonalCasualOccasional: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType },
              psLongTerm: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType }                
            },
            sectorReportCountries: []
          }

          const emptyRow: ICountriesPrivateSectorSplitUpValues = {
            isOK: false,
            isActive: true,
            OBJECTID: -1,
            resto_split_id: '',
            report_rb_id: '',
            ecosystem_id: '',
            intervention_type_id: '',
            splitup_value: '',
            country_id: '',
            country_name: ''
          }

          // if(rbCountryTab.countryprivateSectorResultsAndBenefitsItems!.length > 0)
          // {
          //   rbCountryTab.countryprivateSectorResultsAndBenefitsItems? = item;
          // } 
          // rbCountryTab.countryInterventionSplitUp.countryPrivateSectorSplitUpValues! = emptyRow;
        }
        obj.privateSectorResultsAndBenefitsTab = rbTab;
        //obj.countriesPrivateSectorResultsAndBenefitsTab = rbCountryTab;
      }
      // Validate data
      props.validateData(rbTab, restorePlegdeDetailTab);

      props.setState(obj);
    }
  }

  /**
   * Set delete objectis
   * @param tab
   */
  const setDeleteObjectids = (tab: ICountriesPrivateSectorResultsAndBenefitsTab) => {
    tab.deleteRbObjetIds = tab.countryprivateSectorResultsAndBenefitsItems && tab.countryprivateSectorResultsAndBenefitsItems.length ? tab.countryprivateSectorResultsAndBenefitsItems?.map((p: IPrivateSectorResultsAndBenefitsItem) => { return p.OBJECTID; }) : [];
    const deleteRbJobsObjetIds: number[] = [];

    if (tab.countryprivateSectorResultsAndBenefitsItems && tab.countryprivateSectorResultsAndBenefitsItems.length) {
      tab.countryprivateSectorResultsAndBenefitsItems?.forEach((p: ICountryPrivateSectorResultsAndBenefitsItem) => {
        if (p.privateSectorSocioEconomicImpactsTab) {
          if (p.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && p.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.OBJECTID && p.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.OBJECTID);
          }

          // if (p.privateSectorSocioEconomicImpactsTab.shortTerm && p.privateSectorSocioEconomicImpactsTab.shortTerm.OBJECTID && p.privateSectorSocioEconomicImpactsTab.shortTerm.OBJECTID > 0) {
          //   deleteRbJobsObjetIds.push(p.privateSectorSocioEconomicImpactsTab.shortTerm.OBJECTID);
          // }

          if (p.privateSectorSocioEconomicImpactsTab.psLongTerm && p.privateSectorSocioEconomicImpactsTab.psLongTerm.OBJECTID && p.privateSectorSocioEconomicImpactsTab.psLongTerm.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.privateSectorSocioEconomicImpactsTab.psLongTerm.OBJECTID);
          }

          // if (p.privateSectorSocioEconomicImpactsTab.unspecified && p.privateSectorSocioEconomicImpactsTab.unspecified.OBJECTID && p.privateSectorSocioEconomicImpactsTab.unspecified.OBJECTID > 0) {
          //   deleteRbJobsObjetIds.push(p.privateSectorSocioEconomicImpactsTab.unspecified.OBJECTID);
          // }
        }
      })
    }

    tab.deleteRbJobsObjetIds = deleteRbJobsObjetIds;
  }

  /**
   * Init results and benefits item
   * @param feature
   * @returns
   */
  const initRBItem = (feature: IFeature = Object.create(null)) => {
    const atts: any = feature ? feature.attributes : null;
    const item: ICountryPrivateSectorResultsAndBenefitsItem = {
      isActive: true,
      isOK: false,      
      name0: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.name0] : undefined,
      gid0: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.gid0] : undefined,
      OBJECTID: -1,
      report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID],
      privateSectorAreaOfLandTab: {
        isOK: false,
        ha_restoration_data: '',
        ha_under_resto: 0,
        ha_imp_year: 0,
        ha_tier: '',
        ha_information: '',
        ha_links: '',
        relevant_geospatial_data: '',
        area_restoration_system: '',
        ha_resto_intervention_link: ''
      },
      privateSectorClimateImpactsTab: {
        isOK: true,
        co2_sequestered: 0,
        co2_tier: '',
        co2_systems: '',
        co2_information: '',
        restoration_interventions_aim: '',
        co2_restoration_interventions: '',
        co2_links: '',
        co2_other: '',
        co2_contribution: 0,
        co2_other_tool: '',
        co2_certification: '',
      },
      privateSectorBiodiversityImpactsTab: {
        isOK: true,
        bio_information: '',
        bio_protarea_ha: 0,
        bio_nativearea_ha: 0,
        bio_primarea_ha: 0,
        bio_intactarea_ha: 0,
        bio_redlist: '',
        bio_links: '',
        bio_ha_threat_species: 0
      },
      privateSectorSocioEconomicImpactsTab: {
        isOK: true,
        job_type: '1',
        psSeasonalCasualOccasional: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType },
        //shortTerm: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.shortTermType },
        psLongTerm: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType }
        //unspecified: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.unspecifiedType }
      },
      sectorReportCountries: props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators
    }

    return item;
  }

  /**
   * Set selected results and benefits Item
   * @param tabIndex
   * @param prop
   * @param value 
   */
  const updateSelectedResultsAndBenefitsItem = (tabIndex: number, prop: string, value: any) => {

    if (props.state) {
      const selectedItem: IPrivateSectorResultsAndBenefitsItem | undefined = getSelectedResultsAndBenefitsItem();
      const selectedItemIndex: number = getSelectedResultsAndBenefitsItemIndex();

      if (selectedItemIndex !== -1 && selectedItemIndex !== undefined && selectedItem) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
        const subCountryObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;
        if (selectedItem.gid0 == undefined || selectedItem.gid0 == null) {
          const selectedItemCopy: IPrivateSectorResultsAndBenefitsItem = { ...selectedItem };
          switch (tabIndex) {
            case 0:
              if (prop == "ha_restoration_data") {
                value = value.checked === true ? "1" : "0";
              }
              (selectedItemCopy.privateSectorAreaOfLandTab as any)[prop] = value;
              break;

            case 1:
              (selectedItemCopy.privateSectorClimateImpactsTab as any)[prop] = value;
              break;

            case 2:
              (selectedItemCopy.privateSectorBiodiversityImpactsTab as any)[prop] = value;
              break;

            case 3:
              (selectedItemCopy.privateSectorSocioEconomicImpactsTab as any)[prop] = value;
              break;
          }

          if (subObj.privateSectorResultsAndBenefitsItems) {
            selectedItemCopy.gid0 = '';
            selectedItemCopy.name0 = '';
            subObj.privateSectorResultsAndBenefitsItems[selectedItemIndex] = selectedItemCopy;
            obj.privateSectorResultsAndBenefitsTab = subObj;
            // Validate data
            props.validateData(subObj);

            props.setState(obj);
          }
        }
        else {
          const selectedItemCountryCopy: ICountryPrivateSectorResultsAndBenefitsItem = { ...selectedItem };

          switch (tabIndex) {
            case 0:
              if (prop == "ha_restoration_data") {
                value = value.checked === true ? "1" : "0";
              }
              (selectedItemCountryCopy.privateSectorAreaOfLandTab as any)[prop] = value;
              break;

            case 1:
              (selectedItemCountryCopy.privateSectorClimateImpactsTab as any)[prop] = value;
              break;

            case 2:
              (selectedItemCountryCopy.privateSectorBiodiversityImpactsTab as any)[prop] = value;
              break;

            case 3:
              (selectedItemCountryCopy.privateSectorSocioEconomicImpactsTab as any)[prop] = value;
              break;
          }

          if (subCountryObj.countryprivateSectorResultsAndBenefitsItems) {
            selectedItemCountryCopy.gid0 = localState.selectedCountryId;
            selectedItemCountryCopy.name0 = localState.selectedCountryName;
            subCountryObj.countryprivateSectorResultsAndBenefitsItems[selectedItemIndex] = selectedItemCountryCopy;
            obj.countriesPrivateSectorResultsAndBenefitsTab = subCountryObj;
            // Validate data
            props.validateData(subCountryObj);

            props.setState(obj);
          }
        }
      }
    }
  }

  const updateSelectedSplitValueItem = (tabIndex: number, prop: string, value: any, idx: any) => {
    if (props.state) {
      const selectedItem: IPrivateSectorSplitUpValues | undefined = getSelectedResultsAndBenefitsSplitValue();

      if (idx !== -1 && idx !== undefined && selectedItem) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
        const selectedItemCopy: IPrivateSectorSplitUpValues = { ...selectedItem };
        switch (tabIndex) {
          case 4:
            if (value === undefined) {
              value = '';
            }
            (selectedItemCopy as any)[prop] = value;
            selectedItemCopy.resto_split_id = idx;
            selectedItemCopy.country_id = '';
            selectedItemCopy.country_name = '';
        }

        if (subObj.interventionSplitUp.privateSectorSplitUpValues) {
          subObj.interventionSplitUp.privateSectorSplitUpValues[idx] = selectedItemCopy;
          obj.privateSectorResultsAndBenefitsTab = subObj;
          // Validate data
          props.validateData(subObj);

          props.setState(obj);
        }
      }
    }
  }

  const updateCountrySelectedSplitValueItem = (tabIndex: number, prop: string, value: any, idx: any) => {
    if (props.state) {
      const selectedItem: ICountriesPrivateSectorSplitUpValues | undefined = getCountrySelectedResultsAndBenefitsSplitValue();

      if (idx !== -1 && idx !== undefined && selectedItem && (selectedItem.country_id == localState.selectedCountryId || selectedItem.country_id == '')) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;
        const selectedItemCopy: ICountriesPrivateSectorSplitUpValues = { ...selectedItem };
        switch (tabIndex) {
          case 4:
            if (value === undefined) {
              value = '';
            }
            (selectedItemCopy as any)[prop] = value;//value.replace(',','');
            // if(localState.splitCountrySelectRow != '')
            // {
            //   idx = localState.splitCountrySelectRow + 1;
            //   selectedItemCopy.resto_split_id = idx;
            // }            
            if (selectedItemCopy.resto_split_id == '' && localState.splitCountrySelectRow == '') {
              localState.splitCountrySelectRow = '0';
              selectedItemCopy.resto_split_id = localState.splitCountrySelectRow;
              idx = localState.splitCountrySelectRow;
            }
            if (selectedItemCopy.country_id == '') {
              selectedItemCopy.country_id = localState.selectedCountryId;
              selectedItemCopy.country_name = localState.selectedCountryName;
            }
        }

        if (subObj.countryInterventionSplitUp.countryPrivateSectorSplitUpValues) {
          subObj.countryInterventionSplitUp.countryPrivateSectorSplitUpValues[idx] = selectedItemCopy;
          obj.countriesPrivateSectorResultsAndBenefitsTab = subObj;
          // Validate data
          props.validateData(subObj);

          props.setState(obj);
        }
      }
    }
  }

  const getSelectedResultsAndBenefitsSplitValue = (): IPrivateSectorSplitUpValues | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
      return subObj.interventionSplitUp.privateSectorSplitUpValues![localState.splitSelectRow];//.find((p: IPrivateSectorSplitUpValues, i: number) => p.isActive);
    }

    return undefined;
  }

  const getCountrySelectedResultsAndBenefitsSplitValue = (): ICountriesPrivateSectorSplitUpValues | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;
      return subObj.countryInterventionSplitUp.countryPrivateSectorSplitUpValues.find((p: ICountriesPrivateSectorSplitUpValues, i: number) => (p.country_id == localState.selectedCountryId || p.country_id == '') && p.resto_split_id == localState.splitCountrySelectRow);
    }

    return undefined;
  }

  /**
   * Set selected socio-economic impact item
   * @param tabIndex
   * @param prop
   * @param value 
   */
  const updateSelectedSocioEconomicImpactItem = (accordianIndex: number, prop: string, value: any) => {

    if (props.state) {
      const selectedItem: IPrivateSectorResultsAndBenefitsItem | undefined = getSelectedResultsAndBenefitsItem();
      const selectedItemIndex: number = getSelectedResultsAndBenefitsItemIndex();

      if (selectedItemIndex !== -1 && selectedItemIndex !== undefined && selectedItem) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
        const selectedItemCopy: IPrivateSectorResultsAndBenefitsItem = { ...selectedItem };

        if (prop == 'job_type') {
          (selectedItemCopy.privateSectorSocioEconomicImpactsTab!.job_type) = value;
        }
        else {
          switch (accordianIndex) {
            case 0:
              (selectedItemCopy.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional as any)[prop] = value;
              // if(localState.selectedCountryId != '' && localState.selectedCountryId != null)
              // {
              //   selectedItemCopy.privateSectorSocioEconomicImpactsTab!.country_id = localState.selectedCountryId;
              // }              
              break;

            case 2:
              (selectedItemCopy.privateSectorSocioEconomicImpactsTab?.psLongTerm as any)[prop] = value;
              // if(localState.selectedCountryId != '' && localState.selectedCountryId != null)
              // {
              //   selectedItemCopy.privateSectorSocioEconomicImpactsTab!.country_id = localState.selectedCountryId;
              // }
              break;
          }
        }

        if (subObj.privateSectorResultsAndBenefitsItems) {
          subObj.privateSectorResultsAndBenefitsItems[selectedItemIndex] = selectedItemCopy;
          obj.privateSectorResultsAndBenefitsTab = subObj;

          // Validate data
          props.validateData(subObj);

          props.setState(obj);
        }
      }
    }
  }

  /**
   * Select results and benefits Item
   * @param index 
   */
  const selectResultsAndBenefitsItem = (index: number) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subCountryObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;
      let selectectItem: ICountryPrivateSectorResultsAndBenefitsItem = Object.create(null);

      subCountryObj.countryprivateSectorResultsAndBenefitsItems?.forEach((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => {
        p.isActive = i === index;

        if (i === index) {
          selectectItem = p;
        }
      });
      localState.selectedCountryName = selectectItem.name0!;
      localState.selectedCountryId = selectectItem.gid0!;
      let country_intervention_type_id: number;

      if (props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.length != 0) {
        props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.forEach((el: ICountriesPrivateSectorSplitUpValues) => {
          if (el.country_id === localState.selectedCountryId) {
            country_intervention_type_id = Number([el.intervention_type_id]);
            callCountrySetSelectedInterventionTypes([country_intervention_type_id], el.intervention_type_id, el.resto_split_id, el.country_id);
          }
        });
      }
      const CsplitData = props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.filter((cSplit: ICountriesPrivateSectorSplitUpValues) => cSplit.country_id == localState.selectedCountryId);
      if (CsplitData == undefined || CsplitData.length < 1) {
        const resto_split_id = parseInt(localState.splitCountrySelectRow) + 1;
        const emptyRow: ICountriesPrivateSectorSplitUpValues = {
          isOK: false,
          isActive: true,
          OBJECTID: -1,
          resto_split_id: resto_split_id.toString(),
          report_rb_id: '',
          ecosystem_id: '',
          intervention_type_id: '',
          splitup_value: '',
          country_id: localState.selectedCountryId,
          country_name: localState.selectedCountryName
        }
        props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.push(emptyRow);
      }

      let countryData: any = [];
      countryData = props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryprivateSectorResultsAndBenefitsItems?.find((ele: ICountryPrivateSectorResultsAndBenefitsItem) => ele.gid0 == localState.selectedCountryId);

      if (countryData == undefined) {
        loadAddNewContentData();
      }
      else {
        countryData.isActive = true;
        loadContentData(countryData, true);
      }

      enableDisableTabs(props.state.restorationPledgeTrackingDetailsTab?.location_specific, selectectItem);

      props.setState(obj);
    }
  }

  /**
   * Handle RevertToGlobal dialog
   */
  const handleRevertToGlobalDialogClose = () => setRevertToGlobalDialogShow(false);
  const handleRevertToGlobalDialogShow = () => setRevertToGlobalDialogShow(true);
  const handleRevertToGlobalConfirmRevert = () => {
    handleBreakdownOrRvertReportConfirm();
    handleRevertToGlobalDialogClose();
  }

  /**
   * Handle initiative change
   * @param date
   */
  const handleCO2EstimationSystemChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    updateSelectedResultsAndBenefitsItem(1, ConfigService.getConfig().agol.operationalLayers.reportRb.fields.co2_systems, items && items.length ? items.map(i => i.value).join(',') : '')

    const obj: ILocalState = { ...localState };
    obj.otherCO2EstimationSystemInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);

    if (items.map(i => i.value).indexOf("12") !== -1) {
      obj.otherCO2EmissionOtherInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.co2EmissionKeyValue);
    }

    if (items.map(i => i.value).indexOf("8") !== -1) {
      obj.otherCO2CertificationInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.co2CertificationKeyValue);
    }

    setTheLocalState(obj);
  }


  /**
   * Handle JobsStakeholders change
   * @param date
   */
  const handleJobsStakeholdersChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    //updateSelectedResultsAndBenefitsItem(0, ConfigService.getConfig().agol.operationalLayers.reportRbJobs.fields.jobs_stakeholders, items && items.length ? items.map(i => i.value).join(',') : '')
    updateSelectedSocioEconomicImpactItem(0, 'jobs_stakeholders', items && items.length ? items.map(i => i.value).join(',') : '');

    const obj: ILocalState = { ...localState };
    obj.otherJobsStakerholdersInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
    setTheLocalState(obj);
  }

  /**
   * Handle JobsStakeholders change
   * @param date
   */
  const handleJobsStakeholdersLongTermChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    //updateSelectedResultsAndBenefitsItem(0, ConfigService.getConfig().agol.operationalLayers.reportRbJobs.fields.jobs_stakeholders, items && items.length ? items.map(i => i.value).join(',') : '')
    updateSelectedSocioEconomicImpactItem(2, 'jobs_stakeholders', items && items.length ? items.map(i => i.value).join(',') : '');

    const obj: ILocalState = { ...localState };
    obj.otherJobsStakerholdersLongTermInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
    setTheLocalState(obj);
  }

  /**
   * Check if a field is required in privateSectorAreaOfLandTab tab
   * @param field
   */
  const isRequiredAreaOfLand = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psAreaOfLand, field);
  }

  const isRequiredSplitupValue = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRbHaRestoSplit.psRequiredFields, field);
  }

  /**
   * Check if a field is required in privateSectorClimateImpactsTab tab
   * @param field
   */
  const isRequiredClimImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psClimateImpacts, field);
  }

  /**
   * Check if a field is required in biodiversityImpactsTab tab
   * @param field
   */
  const isRequiredBioImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psBiodiversityImpacts, field);
  }

  /**
   * Check if a field is required in socioEconomicImpactsTab tab
   * @param field
   */
  const isRequiredSociEcoImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.psRequiredFields, field);
  }

  const onInterventionTypesToggle = (currentNode: any) => {
    const obj = localState;

    obj.treeData.forEach((item: any) => {
      if (item.id === currentNode.id) {
        item.expanded = currentNode.expanded;
      }
    });

    setTheLocalState(obj);
  };

  const onCountryInterventionTypesToggle = (currentNode: any) => {
    const obj = localState;

    obj.treeCountryData.forEach((item: any) => {
      if (item.id === currentNode.id) {
        item.expanded = currentNode.expanded;
      }
    });

    setTheLocalState(obj);
  };

  const setExpanded = (items: any[], id: number, expanded: boolean) => {
    items.forEach((item: any) => {
      if (item.id === id) {
        item.expanded = expanded;
      } else if (item.children) {
        setExpanded(item.children, id, expanded);
      }
    });
  }

  const onInterventionTypesChangeSplit = (currentNode: any, selectedNodes: any[]) => {
    let types = '';
    let ids = [];
    let idx = localState.splitSelectRow;
    const obj = localState;

    //Validation of duplicate data in intervention table
    props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues!.forEach((el: any) => {
      let interventionId = Number([el.intervention_type_id]);
      if (interventionId != 0) {
        if (interventionId == currentNode.id && currentNode.checked == true) {
          currentNode.id = '';
          toast.error(t('newReport.resultsAndBenefits.interventionAlreadyExists'));
          return;
        }
      }
    });


    if (selectedNodes && selectedNodes.length) {

      if (currentNode.parent_key) {
        setExpanded(obj.treeData, currentNode.parent_key, true)
      }

      updateSelectedSplitValueItem(4, 'ecosystem_id', currentNode.ecosystem_id, idx);


      types = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id).join(',') : '';
      ids = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id) : [];
    }

    updateSelectedSplitValueItem(4, 'intervention_type_id', types, idx);

    callSetSelectedInterventionTypes(ids, idx);
    setTheLocalState(obj);
  };

  const onCountryInterventionTypesChangeSplit = (currentNode: any, selectedNodes: any[]) => {
    let types = '';
    let ids = [];
    let idx = localState.splitCountrySelectRow == '' ? localState.splitCountrySelectRow = '0' : localState.splitCountrySelectRow;
    const obj = localState;

    //Validation of duplicate data in intervention table
    props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.forEach((el: any) => {
      let interventionId = Number([el.intervention_type_id]);
      if (interventionId != 0) {
        if (interventionId == currentNode.id && currentNode.checked == true && el.country_id == localState.selectedCountryId) {
          currentNode.id = '';
          toast.error(t('newReport.resultsAndBenefits.interventionAlreadyExists'));
          return;
        }
      }
    });


    if (selectedNodes && selectedNodes.length) {

      if (currentNode.parent_key) {
        setExpanded(obj.treeCountryData, currentNode.parent_key, true)
      }

      updateCountrySelectedSplitValueItem(4, 'ecosystem_id', currentNode.ecosystem_id, idx);


      types = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id).join(',') : '';
      ids = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id) : [];
    }

    updateCountrySelectedSplitValueItem(4, 'intervention_type_id', types, idx);

    callCountrySetSelectedInterventionTypes(ids, ids, idx, localState.selectedCountryId);
    setTheLocalState(obj);
  };

  const getSelectedInterventionTypes = (ids: number[], idx: any, obj: ILocalState) => {
    if (ids[0] !== 0) {
      if (localState.treeData[idx] === undefined) {
        localState.treeData[idx] = (JSON.parse(JSON.stringify(localState.treeData[0])));
      }

      setSelectedInterventionTypes(localState.treeData[idx], ids);
    }

  };

  const getCountrySelectedInterventionTypes = (ids: number[], idx: any, obj: ILocalState, countryId: string) => {
    if (ids[0] !== 0) {
      if (localState.treeCountryData[idx] === undefined) {
        localState.treeCountryData[idx] = (JSON.parse(JSON.stringify(localState.treeCountryData[0])));
        localState.treeCountryData[idx][0].countryId = localState.selectedCountryId;
      }

      callCountrySetSelectedInterventionTypes(localState.treeCountryData[idx], ids, idx, countryId);
    }

  };

  const callSetSelectedInterventionTypes = (ids: number[], idx: any) => {
    const obj: ILocalState = { ...localState };
    if (ids[0] !== 0) {
      if (localState.treeData[idx] === undefined) {
        //getLocalStateValue();
        getRefFeatures();
        localState.treeData[idx] = (JSON.parse(JSON.stringify(localState.treeDataCopy)));
      }

      setSelectedInterventionTypes(localState.treeData[idx], ids);
    }

    if (idx == -1) {
      //getLocalStateValue();
      getRefFeatures();
      let pos = (obj.treeData.length) < 0 ? 0 : obj.treeData.length;
      obj.treeData[pos] = (JSON.parse(JSON.stringify(localState.treeDataCopy)));
    }
    else {
      if (obj.treeData[idx]) {
        obj.treeData[idx] = localState.treeData[idx];
      }
      else {
        obj.treeData.push(localState.treeData);
      }
    }

    setTheLocalState(obj);

  };

  const callCountrySetSelectedInterventionTypes = (ids: number[], idx: any, pos: any, countryId: string) => {
    const obj: ILocalState = { ...localState };

    //localState.splitCountrySelectRow = pos;
    if (countryId === localState.selectedCountryId) {
      if (ids[0] !== 0 && idx[0] != '') {
        if (localState.treeCountryData[pos] === undefined) {
          // obj.treeCountryData=[];
          // localState.treeCountryData=[];
          getRefFeatures();
          localState.treeCountryData[pos] = (JSON.parse(JSON.stringify(localState.treeCountryDataCopy)));
          //localState.treeCountryData[pos][0].countryId = localState.selectedCountryId;
        }

        setCountrySelectedInterventionTypes(localState.treeCountryData[pos], idx, pos);
      }

      if (pos === -1) {

        //getRefFeatures();        
        let posLen = (obj.treeCountryData.length) < 0 ? 0 : obj.treeCountryData.length;
        obj.treeCountryData[posLen] = (JSON.parse(JSON.stringify(localState.treeCountryDataCopy)));
        obj.treeCountryData[posLen][0].countryId = localState.selectedCountryId;
      }


      else if (pos != '') {

        if (obj.treeCountryData[pos]) {
          obj.treeCountryData[pos] = (JSON.parse(JSON.stringify(localState.treeCountryData[pos])));
          obj.treeCountryData[pos][0].countryId = countryId;
        }
        else {
          obj.treeCountryData.push(localState.treeCountryData);
        }
      }
    }

    setTheLocalState(obj);

  };


  const setSelectedInterventionTypes = (items: any[], ids: number[]) => {
    items.forEach((item: any) => {
      if (ids.indexOf(item.id) !== -1) {
        item.checked = true;
      }
      else {
        item.checked = false;
      }

      if (item.children) {
        setSelectedInterventionTypes(item.children, ids);
      }
    });
  };

  const setCountrySelectedInterventionTypes = (items: any[], ids: number[], pos: any) => {

    items.forEach((item: any) => {
      if (ids.indexOf(item.id) !== -1) {
        item.checked = true;
      }
      else {
        item.checked = false;
      }

      if (item.children) {
        setCountrySelectedInterventionTypes(item.children, ids, pos);
      }
    });
  };

  const setActive = async (idx: any) => {
    const activeItems = document.querySelectorAll("[class*=splitDiv]");
    activeItems.forEach(el => {
      el.classList.remove('active');
    });

    localState.splitSelectRow = idx;

    const currentItems = document.querySelector(".splitDiv_" + idx);
    currentItems?.classList.add('active');
  }

  const setCountryActive = async (idx: any, restoSplitId: any) => {
    const activeItems = document.querySelectorAll("[class*=splitDiv]");
    activeItems.forEach(el => {
      el.classList.remove('active');
    });

    localState.splitCountrySelectRow = restoSplitId;

    const currentItems = document.querySelector(".splitDiv_" + idx);
    currentItems?.classList.add('active');
  }

  const validateAddIntervention = async () => {
    let resultVal: any = true;
    const relatedData = props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues;
    relatedData?.forEach((id: any) => {
      if (id.intervention_type_id == undefined || (id.splitup_value == "" || id.splitup_value == undefined)) {
        toast.error(t('newReport.resultsAndBenefits.validationError'));
        resultVal = false;
      }
    });
    return resultVal;
  }

  const validateCountryAddIntervention = async () => {
    let resultVal: any = true;
    const relatedData = props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues;
    relatedData?.forEach((id: any) => {
      if (id.intervention_type_id == undefined || (id.splitup_value == "" || id.splitup_value == undefined) && id.country_id == localState.selectedCountryId) {
        toast.error(t('newReport.resultsAndBenefits.validationError'));
        resultVal = false;
      }
    });
    return resultVal;
  }

  const handleAddRow = async () => {
    //const obj = localState;
    var returnData = await validateAddIntervention();
    if (returnData === true) {
      const item = {
        isActive: true,
        isOK: false,
        OBJECTID: -1,
        resto_split_id: '',
        report_rb_id: '',
        ecosystem_id: '',
        intervention_type_id: '',
        splitup_value: '',
        country_id: '',
        country_name: ''
      };

      props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues?.push(item);
      //Added to show empty row on add click.
      const emptyarr = [0];
      callSetSelectedInterventionTypes(emptyarr, -1);
    }
  };

  const handleCountryAddRow = async () => {
    //const obj = localState;
    var returnData = await validateCountryAddIntervention();
    if (returnData === true) {
      let totalRecordCount: number = 0;
      props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues!.forEach((itm: ICountriesPrivateSectorSplitUpValues, idex: number) => {
        totalRecordCount = totalRecordCount + 1;
      });

      const item = {
        isActive: true,
        isOK: false,
        OBJECTID: -1,
        resto_split_id: totalRecordCount.toString(),
        report_rb_id: '',
        ecosystem_id: '',
        intervention_type_id: '',
        splitup_value: '',
        country_id: localState.selectedCountryId,
        country_name: localState.selectedCountryName
      };

      props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues?.push(item);
      //Added to show empty row on add click.
      const emptyarr = [0];
      callCountrySetSelectedInterventionTypes(emptyarr, -1, -1, localState.selectedCountryId);
    }
  };

  const handleRemoveSpecificRow = async (idx: number) => {
    setIsNewRow(false);
    const obj = localState;
    if (idx !== -1) {
      props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues?.splice(idx, 1);
    }

    let array = obj.treeData; // make a separate copy of the array
    var index = array.indexOf(obj.treeData[idx]);
    if (index !== -1) {
      array.splice(index, 1);
      obj.treeData = array;
      setTheLocalState(obj);
    }

    setIsNewRow(true);
    const emptyarr = [0];
    callSetSelectedInterventionTypes(emptyarr, -1);
  }

  const handleCountryRemoveSpecificRow = async (idx: number) => {
    setIsNewRow(false);
    const obj = localState;
    if (idx !== -1) {
      props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues?.splice(idx, 1);
      props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues!.forEach((countrySplit: ICountriesPrivateSectorSplitUpValues, num: number) => {
        countrySplit.resto_split_id = num.toString();
      });    
    }

    let array = obj.treeCountryData; // make a separate copy of the array
    var index = array.indexOf(obj.treeCountryData[idx]);
    if (index !== -1) {
      array.splice(index, 1);
      obj.treeCountryData = array;
      setTheLocalState(obj);
    }

    setIsNewRow(true);
    const emptyarr = [0];
    callCountrySetSelectedInterventionTypes(emptyarr, -1, -1, localState.selectedCountryId);
  }


  const showPopUp = (show: any) => {
    const obj: ILocalState = { ...localState };
    obj.isOpen = show;
    setTheLocalState(obj);
  }
  /**
 * Download a sample shapefile
 */
  const downloadSampleShape = () => {
    saveAs(
      ConfigService.getConfig().agol.downloadAcitivitiesSampleUrl,
      "ActivitiesSamples.zip"
    );
  }
  interface IDataState {
    bio_information?: any[];
  }
  const [dataState, setspeciesName] = useState<IDataState>({});

  const [multiSelections, setMultiSelections] = useState([]);

  const getThreatenedSpeciesByPageListFeatures = async () => {
    try {
      const pageSize = ConfigService.getConfig().iucnRedListPageSize;
      let redLsitResult: any = [];
      let threatenedSpeciesList: any = [];
      let threatenedSpeciesFullList: any = [];
      for (let i = 0; i <= pageSize; i++) {
        const apiURL = ConfigService.getConfig().iucnRedListURL.replace('{pageNo}', i.toString());
        redLsitResult = await fetch(apiURL).then(response => response.json())
        threatenedSpeciesList.push(redLsitResult.result);
      }
      threatenedSpeciesFullList = [...threatenedSpeciesList[0], ...threatenedSpeciesList[1], ...threatenedSpeciesList[2], ...threatenedSpeciesList[3],
      ...threatenedSpeciesList[4], ...threatenedSpeciesList[5], ...threatenedSpeciesList[6], ...threatenedSpeciesList[7], ...threatenedSpeciesList[8],
      ...threatenedSpeciesList[9], ...threatenedSpeciesList[10], ...threatenedSpeciesList[11], ...threatenedSpeciesList[12], ...threatenedSpeciesList[13],
      ...threatenedSpeciesList[14], ...threatenedSpeciesList[15]];
      setspeciesName({
        bio_information: threatenedSpeciesFullList.filter((spec: any) => (spec.main_common_name != null)).map((feat: any) => feat.main_common_name)
      });
    }
    catch (err: any) {
      console.error(err);
    }
  };
  /**
   * Handle country change
   * @param country 
   */
  const onSpeciesNameChange = (selectedData: any) => {
    updateSelectedResultsAndBenefitsItem(2, 'bio_information', selectedData)
  }
  const onSpeciesNameClear = () => {
    updateSelectedResultsAndBenefitsItem(2, 'bio_information', null)
  }

  /**
   * Get selected FocalPoint
   * @param selected
   */
  const setSelectedSpeciesName = (selected: any) => {
    const evt = new CustomEvent("SetAutocompleteValue", { detail: selected });
    window.dispatchEvent(evt);
  }

  const getSelectedSpeciesItem = () => {
    let objSelctedSpeciesArray: any[];
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorResultsAndBenefitsTab = { ...obj.privateSectorResultsAndBenefitsTab } as IPrivateSectorResultsAndBenefitsTab;
      const subCountryObj: ICountriesPrivateSectorResultsAndBenefitsTab = { ...obj.countriesPrivateSectorResultsAndBenefitsTab } as ICountriesPrivateSectorResultsAndBenefitsTab;

      let objSelctedSpecies = subObj.privateSectorResultsAndBenefitsItems?.find((p: IPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive);
      if (!props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode) {
        objSelctedSpecies = subCountryObj.countryprivateSectorResultsAndBenefitsItems?.find((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive);
      }
      //const objSelctedSpecies =subObj.privateSectorResultsAndBenefitsItems?.find((p: IPrivateSectorResultsAndBenefitsItem, i: number) => p.isActive);
      if (objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information == undefined || objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information.length == 0 || objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information == null) {
        return objSelctedSpeciesArray = [];
      }
      else if (objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information.indexOf(',') !== -1) {
        return objSelctedSpeciesArray = objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information.split(',');
      }
      else if (objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information[0].length == 1) {
        return objSelctedSpeciesArray = Array(objSelctedSpecies!.privateSectorBiodiversityImpactsTab.bio_information);
      }
      else {
        return objSelctedSpecies!.privateSectorBiodiversityImpactsTab!.bio_information;
      }
    }

    //return objSelctedSpeciesArray=[''];
  }

  return (
    <div className="oneTabContent resultsAndBenefitsTab row">
      <div className="itemsLeft">
        <div className="breakdownReportByStatesDiv">
          <button className="actionBtn primary" onClick={handleBreakdownOrRvertReportClick}>
            {props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode && <span>{t('newReport.resultsAndBenefits.breakdownReportByCountries')}</span>}
            {!props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode && <span>{t('newReport.resultsAndBenefits.revertToCompanyReport')}</span>}
          </button>
        </div>

        {!props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode &&
          <div className="itemsList">
            {props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryprivateSectorResultsAndBenefitsItems?.map((p: ICountryPrivateSectorResultsAndBenefitsItem, i: number) =>
              <div className={`oneItem ${p.isActive ? 'active' : p.isOK ? 'ok' : 'default'}`} key={i} onClick={() => { selectResultsAndBenefitsItem(i) }}>
                <span className="tabSpan">{p.name0}</span>
                {!p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={p.isOK ? faCheck : faTimes} />}

                {p.isActive && p.sectorReportCountries.map((item: any) => {
                  if (p.name0 == item.country_indicator)
                    return (
                      <div className="oneItemContent">
                        <p className={`subTabItem ${p.isActive && (item.impact_indicator.indexOf('5') != -1) && 'ok'}`}>
                          <span className="commonText">5. {t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</span>
                          {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(item.impact_indicator.indexOf('5') != -1) ? faCheck : faTimes} />}
                        </p>

                        <p className={`subTabItem ${p.isActive && (item.impact_indicator.indexOf('6') != -1) && 'ok'}`}>
                          <span className="commonText">6. {t('newReport.resultsAndBenefits.climateImpactsLabel')}</span>
                          {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(item.impact_indicator.indexOf('6') != -1) ? faCheck : faTimes} />}
                        </p>

                        <p className={`subTabItem ${p.isActive && (item.impact_indicator.indexOf('7') != -1) && 'ok'}`}>
                          <span className="commonText">7. {t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</span>
                          {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(item.impact_indicator.indexOf('7') != -1) ? faCheck : faTimes} />}
                        </p>

                        <p className={`subTabItem ${p.isActive && (item.impact_indicator.indexOf('8') != -1) && 'ok'}`}>
                          <span className="commonText">8. {t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</span>
                          {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(item.impact_indicator.indexOf('8') != -1) ? faCheck : faTimes} />}
                        </p>
                      </div>
                    )
                })}
              </div>
            )}
          </div>
        }
      </div>
      <div className="itemsRight">
        <div className="tabsHeaderDiv">
          <div className={`oneTabItem ${localState.privateSectorAreaOfLandTab.isActive ? 'active' : localState.privateSectorAreaOfLandTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(0)}>5. {t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorClimateImpactsTab.isActive ? 'active' : localState.privateSectorClimateImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(1)}>6. {t('newReport.resultsAndBenefits.climateImpactsLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorBiodiversityImpactsTab.isActive ? 'active' : localState.privateSectorBiodiversityImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(2)}>7. {t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorSocioEconomicImpactsTab.isActive ? 'active' : localState.privateSectorSocioEconomicImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(3)}>8. {t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</div>
        </div>

        <div className="tabsContentDiv">
          <div className="borderHider">
            <div className={`oneBorderHider ${localState.privateSectorAreaOfLandTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorClimateImpactsTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorBiodiversityImpactsTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorSocioEconomicImpactsTab.isActive ? 'active' : ''}`}></div>
          </div>

          {/*privateSectorAreaOfLandTab */
            localState.privateSectorAreaOfLandTab.isActive &&
            <div>
              <div className="oneTabContentNote">
                <span className="oneTabIntroText co2SequesteredFormula marginbtm10">{t('newReport.successFactors.chosenIndicators')}</span>
              </div>
              <div className="oneTabIntro">
                <div className="oneTabIntroNumAndTitle">
                  <span className="oneTabIntroNumber">5</span>
                  <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</span>
                </div>

                {/* <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.hectaresUnderRestorationIntro')}</p> */}
              </div>
              {/* {getSelectedResultsAndBenefitsItem() && */}
              <div className="row multiselectRow required margZero">
                <div>
                  <div className="container">

                    <div className="row clearfix">
                      <p>
                        <span className="titleSpan mediumText">19a. {t('newReport.resultsAndBenefits.restorationInterventions')}</span>
                      </p>
                      <div className='interventionTypes'>
                        <span>
                          <a href="https://www.iucn.org/sites/default/files/content/documents/2021/iucn_restoration_intervention_typology.pdf" target="_blank"> <strong>[Restoration intervention typology (RITTE) list </strong></a>
                          <strong> that appears based on the initial ecosystem type(s) that were selected. Companies can select top level approaches or go into more detail.]
                          </strong>
                        </span>
                      </div>
                      {props.state.privateSectorResultsAndBenefitsTab?.isGlobalMode ?
                        <div className="col-md-12 column">
                          <table
                            className="table table-bordered table-hover"
                            id="tab_logic"
                          >
                            <thead>
                              <tr>
                                <th className="text-center"> </th>
                                <th className="text-center"> {t('newReport.resultsAndBenefits.Interventiontype')} </th>
                                <th className="text-center"> {t('newReport.resultsAndBenefits.Areaunderha')} </th>

                                <th />
                              </tr>
                            </thead>
                            <tbody>

                              {props.state.privateSectorResultsAndBenefitsTab?.interventionSplitUp.privateSectorSplitUpValues?.map((item: any, idx: any) => (
                                <tr className={`splitDiv_${idx}`} onClick={(e) => { setActive(idx) }} id="addr" key={idx}>
                                  <td id="indexID">{idx + 1}</td>
                                  <td className={`tdSplitddl ${isRequiredSplitupValue('intervention_type_id') ? "requiredField" : ""}`}>
                                    {localState.refPledgeEcosystemTypeFeatures && localState.refPledgeEcosystemTypeFeatures.length > 0 &&
                                      <DropdownTreeSelect data={(item.intervention_type_id === "" ? localState.originalData : localState.treeData[idx])} mode="radioSelect" onChange={onInterventionTypesChangeSplit} onNodeToggle={onInterventionTypesToggle} />
                                    }
                                  </td>
                                  <td className='tdsplitup'>
                                    <input
                                      type="text" required={isRequiredSplitupValue('splitup_value')}
                                      name="splitup_value"
                                      value={(item.splitup_value == undefined || item.splitup_value == 'NaN') ? '' : (item.splitup_value).toLocaleString('es-US', { maximumFractionDigits: 2 }) || ''}
                                      //value={item.splitup_value || ''}
                                      onChange={(e) => { updateSelectedSplitValueItem(4, 'splitup_value', e.target.value, idx) }}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <FontAwesomeIcon className="tabIcon deleteIcon" icon={faTrash} onClick={() => { handleRemoveSpecificRow(idx) }} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <button className="createNewBtn primary" onClick={() => handleAddRow()}>
                            <span className="editSpan">{t('addNew')}</span>&nbsp; &nbsp;
                            <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                          </button>
                        </div>
                        :
                        <div className="col-md-12 column">
                          <table
                            className="table table-bordered table-hover"
                            id="tab_logic"
                          >
                            <thead>
                              <tr>
                                <th className="text-center"> </th>
                                <th className="text-center"> {t('newReport.resultsAndBenefits.Interventiontype')} </th>
                                <th className="text-center"> {t('newReport.resultsAndBenefits.Areaunderha')} </th>

                                <th />
                              </tr>
                            </thead>
                            <tbody>

                              {props.state.countriesPrivateSectorResultsAndBenefitsTab?.countryInterventionSplitUp.countryPrivateSectorSplitUpValues?.filter((f: ICountriesPrivateSectorSplitUpValues) => f.country_id === localState.selectedCountryId || (f.country_id === '' && f.OBJECTID === -1)).map((item: any, idx: any) => (
                                <tr className={`splitDiv_${idx}`} onClick={(e) => { setCountryActive(idx, item.resto_split_id) }} id="addr" key={item.resto_split_id}>
                                  <td id="indexID">{idx + 1}</td>

                                  <td className={`tdSplitddl ${isRequiredSplitupValue('intervention_type_id') ? "requiredField" : ""}`}>
                                    {localState.refPledgeEcosystemTypeFeatures && localState.refPledgeEcosystemTypeFeatures.length > 0 &&
                                      <DropdownTreeSelect data={(item.intervention_type_id === "" ? localState.originalCountryData : localState.treeCountryData[item.resto_split_id])} mode="radioSelect" onChange={onCountryInterventionTypesChangeSplit} onNodeToggle={onCountryInterventionTypesToggle} />
                                    }
                                  </td>
                                  <td className='tdsplitup'>
                                    <input
                                      type="text" required={isRequiredSplitupValue('splitup_value')}
                                      name="splitup_value"
                                      value={(item.splitup_value == undefined || item.splitup_value == 'NaN') ? '' : (item.splitup_value).toLocaleString('es-US', { maximumFractionDigits: 2 }) || ''}
                                      //value={item.splitup_value || ''}
                                      onChange={(e) => { updateCountrySelectedSplitValueItem(4, 'splitup_value', e.target.value, item.resto_split_id) }}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <FontAwesomeIcon className="tabIcon deleteIcon" icon={faTrash} onClick={() => { handleCountryRemoveSpecificRow(item.resto_split_id) }} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <button className="createNewBtn primary" onClick={() => handleCountryAddRow()}>
                            <span className="editSpan">{t('addNew')}</span>&nbsp; &nbsp;
                            <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* } */}

              {getSelectedResultsAndBenefitsItem() &&
                <div className='divSpaceTop'>
                  <div className='divDataOnHectare'>
                    <span className='spnlablDataOnHectare'>
                      <label className="form-check-label mediumText" htmlFor="isDataOnHectareCbx">19b. {t('newReport.resultsAndBenefits.restorationHectares')}</label>
                    </span>
                    <label className="switch">
                      <input type="checkbox" id="isDataOnHectareCbx" checked={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data === "1" ? true : false} onChange={(e) => { updateSelectedResultsAndBenefitsItem(0, 'ha_restoration_data', e.target) }}></input>
                      <div className="slider round">
                        <span className="on"><input className="form-check-input chckDataOnHectare" type="checkbox" title={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data === "1" ? "Yes" : "No"} id="isDataOnHectareCbxYes" checked={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == "1"} />Yes</span>
                        <span className="off"><input className="form-check-input chckDataOnHectare" type="checkbox" title={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data === "1" ? "Yes" : "No"} id="isDataOnHectareCbxNo" checked={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == "0"} />No</span>
                      </div>
                    </label>
                  </div>

                  {getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == "1" &&
                    <>
                      <div className="row">
                        <span className="titleSpan mediumText">19c. {t('newReport.resultsAndBenefits.hectareNumber')}</span>
                        <input className="mediumText small hidearrows" required={isRequiredAreaOfLand('ha_under_resto')}
                          maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'ha_under_resto')?.length || 9999} min={0} step={0.1} onKeyUp={Utils.preventNegativeValueFloat}
                          type="number" placeholder={t('newReport.resultsAndBenefits.hectareNumberPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_under_resto || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(0, 'ha_under_resto', e.target.value) }} />
                      </div>
                      <div className="row">
                        <span className="titleSpan mediumText">19d. {t('newReport.resultsAndBenefits.dataClassification')}</span>
                        <div className="col-5 singleDDLDiv">
                          <select className="mediumText"
                            value={getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_tier || ''}
                            onChange={(e) => { updateSelectedResultsAndBenefitsItem(0, 'ha_tier', e.target.value) }}>
                            {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                            {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                          </select>
                        </div>
                      </div>

                      <div className="row sectorShapeUpload">
                        <span className="titleSpan mediumText">19e. {t('newReport.resultsAndBenefits.relevantGeospatialData')}</span>

                        <ActivitiesUpload state={props.state} setState={props.setState} />
                      </div>

                    </>
                  }

                  {(getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == "0" || getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == '' || getSelectedResultsAndBenefitsItem()?.privateSectorAreaOfLandTab?.ha_restoration_data == null) &&
                    <div className="row">
                      <span className="titleSpan mediumText">19f. {t('newReport.resultsAndBenefits.areaUnderRestoration')}</span>
                      <div className="alEditorDiv">
                        <Editor
                          editorState={editorStateArea}
                          onEditorStateChange={handleEditorChangeArea}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true },
                          }}
                        />
                      </div>
                    </div>
                  }

                  <div className="row">
                    <span className="titleSpan mediumText">19g. {t('newReport.resultsAndBenefits.relevantInformation')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateRevInfo}
                        onEditorStateChange={handleEditorChangeRevInfo}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">19h. {t('newReport.resultsAndBenefits.relevantCitations')}</span>
                    <div className={`alEditorDiv ${isRequiredAreaOfLand('ha_links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateRevCit}
                        onEditorStateChange={handleEditorChangeRevCit}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          {/*privateSectorClimateImpactsTab */
            localState.privateSectorClimateImpactsTab.isActive &&
            <div className='climateImpactsTab'>
              <div className="oneTabIntro">
                <div className="oneTabIntroNumAndTitle">
                  <span className="oneTabIntroNumber">6</span>
                  <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.climateImpactsLabel')}</span>
                </div>

                {/* <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.climateImpactsIntro')}</p> */}
              </div>

              {getSelectedResultsAndBenefitsItem() &&
                <div>
                  <div className="row">
                    <span className="titleSpan mediumText simpleSpace">20a. {t('newReport.resultsAndBenefits.co2SequesteredLabel')}</span>
                    <span className="titleSpan mediumText co2SequesteredFormula marginbtm0"><button className='btnFormulaPdf' onClick={() => showPopUp(true)}>{t('newReport.resultsAndBenefits.co2RecommendedFormula')} &nbsp;
                    </button></span>
                    {localState.isOpen && (
                      <div>
                        <div>
                          <CountryGuildLineSplash opened={true}></CountryGuildLineSplash>
                        </div>
                      </div>
                    )}

                    <span className="titleSpan mediumText co2SequesteredFormula marginbtm10">{t('newReport.resultsAndBenefits.co2SequesteredFormula')}</span>
                    <input className="mediumText small" required={isRequiredClimImp('co2_sequestered')}
                      maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_sequestered')?.length || 9999} min={0} step={0.1} onKeyUp={Utils.preventNegativeValueFloat}
                      type="number" placeholder={t('newReport.resultsAndBenefits.co2SequesteredPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_sequestered || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_sequestered', e.target.value) }} />
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">20b. {t('newReport.resultsAndBenefits.co2level')}</span>
                    <div className="col-5 singleDDLDiv">
                      <select className="mediumText requiredField"
                        value={getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_tier || ''}
                        onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_tier', e.target.value) }}>
                        {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                        {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className={`row multiselectRow ${isRequiredClimImp('co2_systems') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">20c. {t('newReport.resultsAndBenefits.co2SystemsLabel')}</span>

                    <div className="col-6">
                      <Select classNamePrefix="multiselect" placeholder={t('newReport.resultsAndBenefits.multiselectPlaceholder')}
                        closeMenuOnSelect={true} isMulti
                        options={localState.refCO2EstimationSystemFeatures.map((i: IRefCO2EstimationSystem) => { return { label: i.value, value: i.key_ } })}
                        onChange={handleCO2EstimationSystemChange}
                        value={
                          localState.refCO2EstimationSystemFeatures.map((i: IRefCO2EstimationSystem) => { return { label: i.value, value: i.key_ } })
                            .filter((option: any) => (getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_systems || '').split(',').indexOf(option.value) !== -1)
                        } />
                    </div>

                    <div className="col-6">
                      <div className='marginBtm5'>
                        <input className="mediumText medium right" required={isRequiredClimImp('co2_other')}
                          maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                          type="text" disabled={!localState.otherCO2EstimationSystemInputEnabled} value={getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_other} onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_other', e.target.value) }} />
                      </div>

                      {getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_systems &&
                        <div className='marginBtm5'>
                          <input className="mediumText medium right" type="text" required={isRequiredClimImp('co2_other_tool')}
                            maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_other_tool')?.length} placeholder={t('newReport.resultsAndBenefits.ifCO2OtherSelected')}
                            disabled={!localState.otherCO2EmissionOtherInputEnabled} value={localState.otherCO2EmissionOtherInputEnabled ? getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_other_tool : ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_other_tool', e.target.value) }} />
                        </div>
                      }

                      {getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_systems &&
                        <div>
                          <input className="mediumText medium right" type="text" required={isRequiredClimImp('co2_certification')}
                            maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_certification')?.length} placeholder={t('newReport.resultsAndBenefits.ifCO2CertificationSelected')}
                            disabled={!localState.otherCO2CertificationInputEnabled} value={localState.otherCO2EmissionOtherInputEnabled ? getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab.co2_certification : ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_certification', e.target.value) }} />
                        </div>
                      }
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">20d. {t('newReport.resultsAndBenefits.co2Sequestration')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateCo2Seq}
                        onEditorStateChange={handleEditorChangeCo2Seq}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                  <div className={`row multiselectRow`}>
                    <span className="titleSpan mediumText">20e. {t('newReport.resultsAndBenefits.restorationInterventionsAim')}</span>
                    <div className="col-11 singleDDLDiv">
                      <select className="mediumText"
                        value={getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.restoration_interventions_aim || ''}
                        onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'restoration_interventions_aim', e.target.value) }}>
                        {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                        {localState.refRestorationAimsFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className={`row multiselectRow`}>
                    <span className="titleSpan mediumText">20f. {t('newReport.resultsAndBenefits.carbonReductions')}</span>
                    <div className="col-11 singleDDLDiv">
                      <select className="mediumText"
                        value={getSelectedResultsAndBenefitsItem()?.privateSectorClimateImpactsTab?.co2_restoration_interventions || ''}
                        onChange={(e) => { updateSelectedResultsAndBenefitsItem(1, 'co2_restoration_interventions', e.target.value) }}>
                        {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                        {localState.refRestorationInterventionFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">20g. {t('newReport.resultsAndBenefits.co2LinksLabel')}</span>
                    <div className={`alEditorDiv ${isRequiredClimImp('co2_links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateCo2Link}
                        onEditorStateChange={handleEditorChangeCo2Link}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          {/*privateSectorBiodiversityImpactsTab */
            localState.privateSectorBiodiversityImpactsTab.isActive &&
            <div className="biodiversityImpactsTab">
              <div className="oneTabIntro">
                <div className="oneTabIntroNumAndTitle">
                  <span className="oneTabIntroNumber">7</span>
                  <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</span>
                </div>

                <p className="oneTabIntroText co2SequesteredFormula marginbtm10">{t('newReport.resultsAndBenefits.biodiversityHeaderNote')}</p>
              </div>
              {getSelectedResultsAndBenefitsItem() &&
                <div>
                  <div className="row">
                    <span className="titleSpan mediumText">21a. {t('newReport.resultsAndBenefits.biodiversityImpacts')}</span>
                    {/* <div className={`alEditorDiv ${isRequiredBioImp('bio_information') ? "requiredField" : ""}`} > */}
                    <div className="isRequiredBioImp">
                      {/* <Editor
                        editorState={editorStateBioImp}
                        onEditorStateChange={handleEditorChangeBioImp}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      /> */}
                      {dataState.bio_information && dataState.bio_information.length ?
                        <MultiSelectAutocomplete
                          multiple
                          className="mediumText requiredField"
                          id="speciesList"
                          labelKey={ConfigService.getConfig().agol?.operationalLayers.reportRb.fields.bio_information}
                          placeholder={t('Species Name')}
                          //data={dataState.bio_information}
                          onChange={onSpeciesNameChange}
                          options={dataState.bio_information}
                          selected={getSelectedSpeciesItem()}
                          //value={getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_information}
                          onClear={onSpeciesNameClear} /> :
                        <Spinner animation="grow" variant="dark" />
                      }
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">21b. {t('newReport.resultsAndBenefits.bioProtAreaHaLabel')}</span>
                    <input className="mediumText verySmall"
                      maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_protarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                      type="number" placeholder={t('newReport.resultsAndBenefits.bioProtAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_protarea_ha || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(2, 'bio_protarea_ha', e.target.value) }} />
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">21c. {t('newReport.resultsAndBenefits.bioAreaHaLabel')}</span>

                    <p>
                      <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioNativeAreaHaLabel')}</span>
                      <input className="mediumText verySmall sameLineElem"
                        maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_nativearea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                        type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_nativearea_ha || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(2, 'bio_nativearea_ha', e.target.value) }} />

                      <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioPrimAreaHaLabel')}</span>
                      <input className="mediumText verySmall sameLineElem"
                        maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_primarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                        type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_primarea_ha || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(2, 'bio_primarea_ha', e.target.value) }} />

                      <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioIntactAreaHaLabel')}</span>
                      <input className="mediumText verySmall sameLineElem"
                        maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_intactarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                        type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorBiodiversityImpactsTab?.bio_intactarea_ha || ''} onChange={(e) => { updateSelectedResultsAndBenefitsItem(2, 'bio_intactarea_ha', e.target.value) }} />
                    </p>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">21d. {t('newReport.resultsAndBenefits.bioRedlistLabel')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateBioRed}
                        onEditorStateChange={handleEditorChangeBioRed}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">21e. {t('newReport.resultsAndBenefits.bioLinksLabel')}</span>
                    <div className={`alEditorDiv ${isRequiredBioImp('bio_links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateBioLink}
                        onEditorStateChange={handleEditorChangeBioLink}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                </div>
              }
            </div>
          }

          {/*privateSectorSocioEconomicImpactsTab */
            localState.privateSectorSocioEconomicImpactsTab.isActive &&
            <div className="socioEconomicImpactsTab">
              <div className="oneTabIntro">
                <div className="oneTabIntroNumAndTitle">
                  <span className="oneTabIntroNumber">8</span>
                  <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</span>
                </div>

                <p className="oneTabIntroText co2SequesteredFormula marginbtm10">{t('newReport.resultsAndBenefits.economyHeaderNote')}</p>
              </div>

              {getSelectedResultsAndBenefitsItem() &&
                <div className="accordionDiv">
                  <div className="row">
                    <span className="titleSpan ecoTitleSpan mediumText">22. {t('newReport.resultsAndBenefits.jobTypes')}</span>
                    <div className="col-5 singleDDLDiv">
                      <select className="mediumText"
                        value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.job_type || '1'}
                        onChange={(e) => { updateSelectedSocioEconomicImpactItem(0, 'job_type', e.target.value) }}>
                        {/* {<option value="-1" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}  */}
                        {localState.jobTypesFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                      </select>
                    </div>
                  </div>

                  {/** seasonalCasualOccasional*/}
                  {(getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.job_type == '1' || getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.job_type == '3') &&
                    <Accordion className='ecoAccordin'>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel1')}</Accordion.Header>
                        <Accordion.Body>
                          <div className="row">
                            <span className="titleSpan mediumText">22a. {t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>
                            <input className="mediumText small" required={isRequiredSociEcoImp('eco_jobs')}
                              maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                              type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_jobs || ''} onChange={(e) => { updateSelectedSocioEconomicImpactItem(0, 'eco_jobs', e.target.value) }} />
                          </div>

                          <div className={`row multiselectRow`}>
                            <span className="titleSpan mediumText">22b. {t('newReport.resultsAndBenefits.stakeholdersBenefit')}</span>
                            <div className="col-6">
                              <Select classNamePrefix="multiselect" placeholder={t('newReport.resultsAndBenefits.multiselectPlaceholder')}
                                closeMenuOnSelect={true} isMulti
                                options={localState.refJobsStakeholdersFeature.map((i: IRefJobsStakeholdersFeature) => { return { label: i.value, value: i.key_ } })}
                                onChange={handleJobsStakeholdersChange}
                                value={
                                  localState.refJobsStakeholdersFeature.map((i: IRefJobsStakeholdersFeature) => { return { label: i.value, value: i.key_ } })
                                    .filter((option: any) => (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.jobs_stakeholders || '').split(',').indexOf(option.value) !== -1)
                                } />
                            </div>
                            <div className="col-6">
                              <input className="mediumText medium right" required={isRequiredSociEcoImp('jobs_stakeholders_other')}
                                maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'jobs_stakeholders_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                                type="text" disabled={!localState.otherJobsStakerholdersInputEnabled} value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.jobs_stakeholders_other} onChange={(e) => { updateSelectedSocioEconomicImpactItem(0, 'jobs_stakeholders_other', e.target.value) }} />
                            </div>
                          </div>

                          <div className="row">
                            <span className="titleSpan mediumText">22c. {t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                            <div className="col-5 singleDDLDiv">
                              <select className="mediumText"
                                value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_tiers || '-999'}
                                onChange={(e) => { updateSelectedSocioEconomicImpactItem(0, 'eco_tiers', e.target.value) }}>
                                {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                                {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                              </select>
                            </div>
                          </div>
                          <div className="row">
                            <span className="titleSpan mediumText">22d. {t('newReport.resultsAndBenefits.socioEconomicBenefits')}</span>
                            <div className="alEditorDiv">
                              <Editor
                                editorState={editorStateSeasonalEcoBen}
                                onEditorStateChange={handleEditorChangeSeasonalEcoBen}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                                toolbar={{
                                  options: ['link'],
                                  link: { inDropdown: true },
                                }}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <span className="titleSpan mediumText">22e. {t('newReport.resultsAndBenefits.relevantCitationsEconomy')}</span>
                            <div className={`alEditorDiv ${isRequiredSociEcoImp('eco_links') ? "requiredField" : ""}`} >
                              <Editor
                                editorState={editorStateSeasonalRevEco}
                                onEditorStateChange={handleEditorChangeSeasonalRevEco}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                                toolbar={{
                                  options: ['link'],
                                  link: { inDropdown: true },
                                }}
                              />
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  }

                  {/** longTerm*/}
                  <Accordion>
                    {(getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.job_type == '2' || getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.job_type == '3') &&
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel3')}</Accordion.Header>
                        <Accordion.Body>
                          <div className="row">
                            <span className="titleSpan mediumText">22a. {t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>
                            <input className="mediumText small" required={isRequiredSociEcoImp('eco_jobs')}
                              maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                              type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_jobs || ''} onChange={(e) => { updateSelectedSocioEconomicImpactItem(2, 'eco_jobs', e.target.value) }} />
                          </div>

                          <div className={`row multiselectRow`}>
                            <span className="titleSpan mediumText">22b. {t('newReport.resultsAndBenefits.stakeholdersBenefit')}</span>
                            <div className="col-6">
                              <Select classNamePrefix="multiselect" placeholder={t('newReport.resultsAndBenefits.multiselectPlaceholder')}
                                closeMenuOnSelect={true} isMulti
                                options={localState.refJobsStakeholdersFeature.map((i: IRefJobsStakeholdersFeature) => { return { label: i.value, value: i.key_ } })}
                                onChange={handleJobsStakeholdersLongTermChange}
                                value={
                                  localState.refJobsStakeholdersFeature.map((i: IRefJobsStakeholdersFeature) => { return { label: i.value, value: i.key_ } })
                                    .filter((option: any) => (getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.jobs_stakeholders || '').split(',').indexOf(option.value) !== -1)
                                } />
                            </div>
                            <div className="col-6">
                              <input className="mediumText medium right" required={isRequiredSociEcoImp('jobs_stakeholders_other')}
                                maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'jobs_stakeholders_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                                type="text" disabled={!localState.otherJobsStakerholdersLongTermInputEnabled} value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.jobs_stakeholders_other} onChange={(e) => { updateSelectedSocioEconomicImpactItem(2, 'jobs_stakeholders_other', e.target.value) }} />
                            </div>
                          </div>

                          <div className="row">
                            <span className="titleSpan mediumText">22c. {t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                            <div className="col-5 singleDDLDiv">
                              <select className="mediumText"
                                value={getSelectedResultsAndBenefitsItem()?.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_tiers || '-999'}
                                onChange={(e) => { updateSelectedSocioEconomicImpactItem(2, 'eco_tiers', e.target.value) }}>
                                {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                                {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                              </select>
                            </div>
                          </div>
                          <div className="row">
                            <span className="titleSpan mediumText">22d. {t('newReport.resultsAndBenefits.socioEconomicBenefits')}</span>
                            <div className="alEditorDiv">
                              <Editor
                                editorState={editorStateLongTermEcoBen}
                                onEditorStateChange={handleEditorChangeLongTermEcoBen}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                                toolbar={{
                                  options: ['link'],
                                  link: { inDropdown: true },
                                }}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <span className="titleSpan mediumText">22e.{t('newReport.resultsAndBenefits.relevantCitationsEconomy')}</span>
                            <div className={`alEditorDiv ${isRequiredSociEcoImp('eco_links') ? "requiredField" : ""}`} >
                              <Editor
                                editorState={editorStateLongTermRevEco}
                                onEditorStateChange={handleEditorChangeLongTermRevEco}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                                toolbar={{
                                  options: ['link'],
                                  link: { inDropdown: true },
                                }}
                              />
                            </div>
                          </div>

                        </Accordion.Body>
                      </Accordion.Item>
                    }
                  </Accordion>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <LoadingOverlay
        active={localState.isFetchingReportData}
        spinner
        text={localState.isFetchingReportData ? t('newReport.fetchingReportData') : ''}>
      </LoadingOverlay>
      <Modal show={showRevertToGlobalDialog} onHide={handleRevertToGlobalDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.resultsAndBenefits.confirmRevertToGlobalTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.resultsAndBenefits.confirmResultBenefitRevertToGlobalContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handleRevertToGlobalDialogClose}>
            {t('newReport.resultsAndBenefits.cancelRevertToGlobal')}
          </button>
          <button className="dialogBtn primary" onClick={handleRevertToGlobalConfirmRevert}>
            {t('newReport.resultsAndBenefits.confirmRevertToGlobal')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SectorResultsAndBenefits;

